module.exports = __webpack_public_path__ + "static/media/node.a1231528.svg";